module.exports = __webpack_public_path__ + "img/operation.94cc6f1c.svg";